import { render, staticRenderFns } from "./ContactInformationForm.vue?vue&type=template&id=1da305ba&scoped=true"
import script from "./ContactInformationForm.vue?vue&type=script&lang=js"
export * from "./ContactInformationForm.vue?vue&type=script&lang=js"
import style0 from "./ContactInformationForm.vue?vue&type=style&index=0&id=1da305ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da305ba",
  null
  
)

export default component.exports